import dayjs from "dayjs";

export const REQUEST_STATUS_TABS = [
  { value: "PENDING", label: "Pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "all", label: "All" },
];

export const REQUEST_TYPE_LABELS = {
  TENANT_NEW: "New tenant vehicle",
  TENANT_UPDATE: "Tenant vehicle update",
  GUEST: "Guest vehicle",
  GUEST_UPDATE: "Guest vehicle update",
};

// Guest invites and guest changes to an approved guest vehicle
export const isGuestType = (type) => type === "GUEST" || type === "GUEST_UPDATE";

export const STATUS_LABELS = {
  INVITED: "Invited",
  AWAITING_PAYMENT: "Awaiting payment",
  PENDING: "Pending approval",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
  EXPIRED: "Expired",
};

// parking_passes.status for a paid pass (Tenant module ParkingPass::STATUS_PAID)
export const PASS_STATUS_PAID = 2;

export const apiErrorMessage = (error, fallback) => error?.response?.data?.message || fallback;

export const formatDateTime = (value) => (value ? dayjs(value).format("MMM D, YYYY h:mm A") : "-");

export const vehicleText = (item) => [item?.color, item?.make, item?.model].filter(Boolean).join(" ") || "-";

export const requesterName = (item) =>
  isGuestType(item?.type) ? [item?.guest_fname, item?.guest_lname].filter(Boolean).join(" ") : item?.tenant_name || "-";
